var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540,
    height: 255,
    viewBox: "0 0 540 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12546",
    "data-name": "Rectangle 12546",
    width: 540,
    height: 255,
    transform: "translate(405 160)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(-405 -160)",
    opacity: 0.8,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company-rafiki",
    transform: "translate(427.101 105.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51492",
    "data-name": "Group 51492",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-151",
    transform: "translate(0 54.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12641",
    "data-name": "Rectangle 12641",
    width: 25.953,
    height: 0.196,
    transform: "translate(326.587 269.157)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12642",
    "data-name": "Rectangle 12642",
    width: 6.809,
    height: 0.196,
    transform: "translate(252.733 271.289)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12643",
    "data-name": "Rectangle 12643",
    width: 15.037,
    height: 0.196,
    transform: "translate(310.766 261.885)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12644",
    "data-name": "Rectangle 12644",
    width: 33.843,
    height: 0.196,
    transform: "translate(41.107 263.202)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12645",
    "data-name": "Rectangle 12645",
    width: 4.96,
    height: 0.196,
    transform: "translate(81.933 263.202)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12646",
    "data-name": "Rectangle 12646",
    width: 73.407,
    height: 0.196,
    transform: "translate(103.019 266.509)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47466",
    "data-name": "Path 47466",
    d: "M193.981,276.6H42.676a4.474,4.474,0,0,1-4.466-4.474V59.435A4.474,4.474,0,0,1,42.676,55h151.3a4.474,4.474,0,0,1,4.474,4.474V272.126A4.474,4.474,0,0,1,193.981,276.6ZM42.676,55.157a4.278,4.278,0,0,0-4.271,4.278V272.126a4.278,4.278,0,0,0,4.271,4.278h151.3a4.286,4.286,0,0,0,4.278-4.278V59.435a4.286,4.286,0,0,0-4.278-4.278Z",
    transform: "translate(-8.269 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47467",
    "data-name": "Path 47467",
    d: "M410.287,276.85H258.974a4.482,4.482,0,0,1-4.474-4.474V59.684a4.482,4.482,0,0,1,4.474-4.474H410.287a4.474,4.474,0,0,1,4.459,4.474V272.376a4.474,4.474,0,0,1-4.459,4.474ZM258.974,55.406a4.286,4.286,0,0,0-4.278,4.278V272.376a4.286,4.286,0,0,0,4.278,4.278H410.287a4.286,4.286,0,0,0,4.278-4.278V59.684a4.286,4.286,0,0,0-4.278-4.278Z",
    transform: "translate(-55.075 -55.045)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12647",
    "data-name": "Rectangle 12647",
    width: 391.798,
    height: 0.196,
    transform: "translate(0 256.549)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47468",
    "data-name": "Path 47468",
    d: "M75.287,139.955h71.064c9.105,0,11.3-12.741,2.7-15.735l-.337-.11c9.513-7.93-11.354-24.636-34.024-1.5,1.771-7.711-18.383-4.921-24.542,5.6C87.957,121.3,68.744,133.3,75.287,139.955Z",
    transform: "translate(-16 -67.081)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47469",
    "data-name": "Path 47469",
    d: "M317.387,100.254H360s9.991-3.761,8.7-13.729-16.377-1.661-16.377-1.661,4.568-13.909-10.038-9.959a21.63,21.63,0,0,0-16.032,17.733S307.059,89.284,317.387,100.254Z",
    transform: "translate(-68.023 -59.155)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47470",
    "data-name": "Path 47470",
    d: "M367.634,138.479h28.131s6.6-2.484,5.744-9.066-10.814-1.1-10.814-1.1,3.017-9.176-6.629-6.574a14.269,14.269,0,0,0-10.579,11.707S360.816,131.247,367.634,138.479Z",
    transform: "translate(-79.122 -69.343)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47471",
    "data-name": "Path 47471",
    d: "M358.665,309.746l-.078-8.322v-.462l-.071-7.421v-.47l-.07-7.052v-.462l-.063-6.715V278.4l-.063-6.41v-.407l-.063-6.128v-.384l-.055-5.853v-.376L358.156,254a3.525,3.525,0,0,1-.784.368v4.09h-5.187l4.184-3.832a8.422,8.422,0,0,1-1.309.157l-3.448,3.134.063-3.7a2.884,2.884,0,0,1-.784-.47l-.094,5.078v.376l-.094,5.853v.4l-.118,6.1v.407l-.11,6.394v.439l-.118,6.715v.462l-.125,7.052v.478l-.133,7.413v.5l-.141,8.314-.8,35.889,10,.118Zm-1.042-1.567-6.026-6.512h5.987Zm-.094-7.287h-5.963l5.916-6.222Zm.063-9.145-5.736-5.877h5.7Zm-.071-6.684h-5.673l5.642-5.65Zm-.039-7.781L352,271.945h5.438Zm0-6.167h-5.422l5.375-5.156Zm-.094-11.871v4.882l-5.227-4.858Zm-5.893,1.113,5.227,4.874h-5.3Zm-.078,5.72h5.3l-5.415,5.109Zm-.11,7.139,5.485,5.344H351.26Zm-.078,6.159h5.556L351.15,285Zm-.11,7.781,5.744,5.9h-5.822Zm-.055,6.692h5.806l-5.924,6.19Zm-.039,8.2,6.026,6.535h-6.12Z",
    transform: "translate(-75.56 -98.01)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47472",
    "data-name": "Path 47472",
    d: "M358.526,252.866h-.4l-.29-.266-2.351,2.194a9.242,9.242,0,0,0,1.3-.157l.979-.893v.6a3.823,3.823,0,0,0,.784-.368Zm-7.256.047v.878a3.47,3.47,0,0,0,.784.47v-1.348Z",
    transform: "translate(-76.016 -97.762)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47473",
    "data-name": "Path 47473",
    d: "M359.217,250.448a1.41,1.41,0,0,1-.415,1.191l-.282.266a3.787,3.787,0,0,1-.47.321,3.826,3.826,0,0,1-.784.368,5.286,5.286,0,0,1-.979.29,9.238,9.238,0,0,1-1.3.157H354.4a7.154,7.154,0,0,1-2.8-.564,3.472,3.472,0,0,1-.784-.47l-.07-.055-.259-.251a1.3,1.3,0,0,1-.376-1.152l.6-3.338H349.14l5.485-2.782,5.712,2.6h-1.606Z",
    transform: "translate(-75.555 -95.993)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47474",
    "data-name": "Path 47474",
    d: "M394.12,257.45l.212,88.993h50.448l.282-88.993Z",
    transform: "translate(-85.289 -98.811)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47475",
    "data-name": "Path 47475",
    d: "M406.69,243l.023,19.841H437.94L437.979,243Z",
    transform: "translate(-88.009 -95.684)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47476",
    "data-name": "Path 47476",
    d: "M404.816,266.68h-6.6l-.008-5.94h6.6Z",
    transform: "translate(-86.174 -99.523)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12648",
    "data-name": "Rectangle 12648",
    width: 6.598,
    height: 5.947,
    transform: "translate(324.699 161.209)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12649",
    "data-name": "Rectangle 12649",
    width: 6.598,
    height: 5.947,
    transform: "translate(337.361 161.209)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47477",
    "data-name": "Path 47477",
    d: "M453.278,266.68h-6.6l.016-5.94h6.6Z",
    transform: "translate(-96.664 -99.523)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47478",
    "data-name": "Path 47478",
    d: "M404.747,280.549h-6.441l-.016-5.8h6.449Z",
    transform: "translate(-86.192 -102.555)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12650",
    "data-name": "Rectangle 12650",
    width: 6.449,
    height: 5.799,
    transform: "translate(324.746 172.195)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12651",
    "data-name": "Rectangle 12651",
    width: 6.449,
    height: 5.799,
    transform: "translate(337.393 172.195)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47479",
    "data-name": "Path 47479",
    d: "M453.139,280.549H446.69l.016-5.8h6.449Z",
    transform: "translate(-96.666 -102.555)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47480",
    "data-name": "Path 47480",
    d: "M404.718,294.068h-6.292l-.016-5.658h6.3Z",
    transform: "translate(-86.218 -105.511)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12652",
    "data-name": "Rectangle 12652",
    width: 6.3,
    height: 5.658,
    transform: "translate(324.832 182.899)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12653",
    "data-name": "Rectangle 12653",
    width: 6.3,
    height: 5.658,
    transform: "translate(337.455 182.899)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12654",
    "data-name": "Rectangle 12654",
    width: 6.723,
    height: 6.065,
    transform: "translate(324.534 152.582)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12655",
    "data-name": "Rectangle 12655",
    width: 6.731,
    height: 6.065,
    transform: "translate(337.205 152.582)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47481",
    "data-name": "Path 47481",
    d: "M453.052,294.068H446.76l.008-5.658h6.3Z",
    transform: "translate(-96.681 -105.511)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47482",
    "data-name": "Path 47482",
    d: "M404.737,307.274h-6.151l-.016-5.524h6.159Z",
    transform: "translate(-86.252 -108.398)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12656",
    "data-name": "Rectangle 12656",
    width: 6.151,
    height: 5.524,
    transform: "translate(324.941 193.352)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47483",
    "data-name": "Path 47483",
    d: "M436.931,307.274H430.78l.008-5.524h6.151Z",
    transform: "translate(-93.223 -108.398)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47484",
    "data-name": "Path 47484",
    d: "M453.021,307.274H446.87l.016-5.524h6.151Z",
    transform: "translate(-96.705 -108.398)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47485",
    "data-name": "Path 47485",
    d: "M404.892,321.9h-6.856l-.016-6.151h6.864Z",
    transform: "translate(-86.133 -111.427)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47486",
    "data-name": "Path 47486",
    d: "M420.956,321.9h-6.849l-.008-6.151h6.864Z",
    transform: "translate(-89.613 -111.427)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47487",
    "data-name": "Path 47487",
    d: "M437.026,321.9H430.17V315.75h6.864Z",
    transform: "translate(-93.091 -111.427)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47488",
    "data-name": "Path 47488",
    d: "M453.086,321.9H446.23l.016-6.151H453.1Z",
    transform: "translate(-96.566 -111.427)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47489",
    "data-name": "Path 47489",
    d: "M404.985,334.442h-6.7l-.016-6h6.708Z",
    transform: "translate(-86.187 -114.174)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12657",
    "data-name": "Rectangle 12657",
    width: 6.7,
    height: 6.002,
    transform: "translate(324.675 214.266)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12658",
    "data-name": "Rectangle 12658",
    width: 6.7,
    height: 6.002,
    transform: "translate(337.267 214.266)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47490",
    "data-name": "Path 47490",
    d: "M453.16,334.442h-6.7l.016-6h6.708Z",
    transform: "translate(-96.616 -114.174)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47491",
    "data-name": "Path 47491",
    d: "M404.853,348.556h-6.535l-.008-5.846h6.535Z",
    transform: "translate(-86.196 -117.262)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12659",
    "data-name": "Rectangle 12659",
    width: 6.535,
    height: 5.846,
    transform: "translate(324.683 225.448)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12660",
    "data-name": "Rectangle 12660",
    width: 6.535,
    height: 5.846,
    transform: "translate(337.244 225.448)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47492",
    "data-name": "Path 47492",
    d: "M452.937,348.556H446.41l.008-5.846h6.535Z",
    transform: "translate(-96.605 -117.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47493",
    "data-name": "Path 47493",
    d: "M404.9,361.387h-6.379l-.008-5.7h6.378Z",
    transform: "translate(-86.239 -120.071)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47494",
    "data-name": "Path 47494",
    d: "M452.951,361.387H446.58l.008-5.7h6.378Z",
    transform: "translate(-96.642 -120.071)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47495",
    "data-name": "Path 47495",
    d: "M433.5,355.69H414.46l.039,1.434h.525l.008,10.579h1.9l-.008-10.579h14.136l-.016,10.579h1.9l.016-10.579h.572Z",
    transform: "translate(-89.691 -120.071)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47496",
    "data-name": "Path 47496",
    d: "M424.782,368.1H417.73V357.52h7.06Z",
    transform: "translate(-90.399 -120.467)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47497",
    "data-name": "Path 47497",
    d: "M433.57,368.1h-7.06l.008-10.579h7.068Z",
    transform: "translate(-92.299 -120.467)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47498",
    "data-name": "Path 47498",
    d: "M376.618,293.58l.141,60.682H313.5l-.58-60.682Z",
    transform: "translate(-67.717 -106.63)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47499",
    "data-name": "Path 47499",
    d: "M378.754,308.834h7.9l-.023-7.084h-7.9Z",
    transform: "translate(-81.959 -108.398)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47500",
    "data-name": "Path 47500",
    d: "M358.639,308.834h7.9l-.031-7.084H358.6Z",
    transform: "translate(-77.603 -108.398)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47501",
    "data-name": "Path 47501",
    d: "M338.527,308.834h7.9l-.047-7.084h-7.9Z",
    transform: "translate(-73.249 -108.398)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47502",
    "data-name": "Path 47502",
    d: "M318.413,308.834h7.9l-.063-7.084h-7.9Z",
    transform: "translate(-68.892 -108.398)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47503",
    "data-name": "Path 47503",
    d: "M378.371,326.334h8.51l-.024-7.624H378.34Z",
    transform: "translate(-81.874 -112.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47504",
    "data-name": "Path 47504",
    d: "M358.3,326.334h8.51l-.039-7.624H358.25Z",
    transform: "translate(-77.527 -112.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47505",
    "data-name": "Path 47505",
    d: "M338.215,326.334h8.51l-.047-7.624H338.16Z",
    transform: "translate(-73.179 -112.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47506",
    "data-name": "Path 47506",
    d: "M318.141,326.334h8.51l-.063-7.624H318.07Z",
    transform: "translate(-68.832 -112.068)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47507",
    "data-name": "Path 47507",
    d: "M378.654,342.539h8.259l-.016-7.389H378.63Z",
    transform: "translate(-81.937 -115.626)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47508",
    "data-name": "Path 47508",
    d: "M358.6,342.539h8.259l-.031-7.389H358.56Z",
    transform: "translate(-77.594 -115.626)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47509",
    "data-name": "Path 47509",
    d: "M338.545,342.539H346.8l-.047-7.389H338.49Z",
    transform: "translate(-73.251 -115.626)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47510",
    "data-name": "Path 47510",
    d: "M318.483,342.539h8.259l-.055-7.389H318.42Z",
    transform: "translate(-68.907 -115.626)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47511",
    "data-name": "Path 47511",
    d: "M378.881,359.172h8.008l-.016-7.162H378.85Z",
    transform: "translate(-81.985 -119.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47512",
    "data-name": "Path 47512",
    d: "M318.793,359.172h8.016l-.063-7.162H318.73Z",
    transform: "translate(-68.975 -119.274)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47513",
    "data-name": "Path 47513",
    d: "M338.08,352.01h24.785l.008,2.163H361.29l.063,12.733h-2.3l-.063-12.733h-17l.086,12.733h-2.288l-.094-12.733H338.1Z",
    transform: "translate(-73.162 -119.274)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47514",
    "data-name": "Path 47514",
    d: "M354.068,367.5h8.486l-.063-12.733h-8.5Z",
    transform: "translate(-76.605 -119.872)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47515",
    "data-name": "Path 47515",
    d: "M343.086,367.5h8.486l-.07-12.733H343Z",
    transform: "translate(-74.227 -119.872)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47516",
    "data-name": "Path 47516",
    d: "M151.437,226.421v-2.852a.345.345,0,0,0-.682,0V226.7a.36.36,0,0,0,.337.345,1.371,1.371,0,1,1-1.371,1.363c0-.431-.721-.431-.682,0a2.077,2.077,0,0,0,3.5,1.457,2.053,2.053,0,0,0-1.1-3.448Z",
    transform: "translate(-32.252 -91.416)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47517",
    "data-name": "Path 47517",
    d: "M85.987,201.027V207.2l-6.512-6.512-.321.321H78.7v58.77h8.2v-58.77Zm-6.378,44.837,5.736,5.736H79.609Zm0-14.583,5.736,5.736H79.609Zm0-14.575,5.736,5.736H79.609Zm0-14.583,5.736,5.744H79.609Zm5.736,6.645-5.736,5.744v-5.744Zm.643.643v5.744H80.252Zm-.643,13.94-5.736,5.736v-5.736Zm.643.643v5.736H80.252Zm-.643,13.932-5.736,5.744v-5.744Zm.643.619v5.744H80.252Zm-.643,13.94-5.736,5.736v-5.736Zm-5.093,6.433,5.736-5.767v5.767Zm5.736-7.961-5.736-5.736h5.736Zm0-14.583-5.736-5.736h5.736Zm0-14.575-5.736-5.736h5.736Z",
    transform: "translate(-17.031 -86.528)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47518",
    "data-name": "Path 47518",
    d: "M79.86,176.42v11.425h.893V183.48l4.7,4.7.321-.321h.462V176.42Zm4.811.909-3.918,3.918v-3.918Zm.643,9.4L81.4,182.814h3.918ZM81.4,181.913,85.314,178v3.918Z",
    transform: "translate(-17.282 -81.276)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12661",
    "data-name": "Rectangle 12661",
    width: 10.931,
    height: 10.931,
    transform: "translate(36.68 114.499)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47519",
    "data-name": "Path 47519",
    d: "M129.076,210.616h-.611V189.6l-50.91-16.886H74.193L46.931,189.631l-.321-.509,27.4-17.012h3.644l.047.016,51.373,17.035Z",
    transform: "translate(-10.087 -80.343)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47520",
    "data-name": "Path 47520",
    d: "M122.764,199.964h.627l6.394-6.394H46.23v6.371h76.534Zm.909-5.485h3.918l-3.918,3.918Zm-76.534,4.553v-3.918l3.918,3.918Zm4.561-.643-3.918-3.918H51.7Zm.909-3.918h3.918l-3.918,3.918Zm4.561,4.553H53.251l3.918-3.918Zm.909,0v-3.918L62,199.024Zm4.553-.643-3.918-3.918h3.918Zm.909-3.918h3.918l-3.918,3.918Zm4.561,4.553H64.182L68.1,195.1Zm.909,0V195.1l3.918,3.918Zm4.561-.643-3.918-3.918H73.57Zm.909-3.918H78.4l-3.918,3.918Zm4.553,4.553H75.113l3.918-3.918Zm.909,0V195.09l3.918,3.918Zm4.561-.643-3.918-3.918H84.5Zm.909-3.918h3.918l-3.918,3.918ZM89.962,199H86.045l3.918-3.918Zm.909,0v-3.918L94.789,199Zm4.561-.643-3.918-3.918h3.918Zm.909-3.918h3.918l-3.918,3.918Zm4.561,4.553H96.983l3.918-3.918Zm.909,0v-3.918l3.918,3.918Zm4.553-.643-3.918-3.918h3.918Zm.909-3.918h3.918l-3.918,3.918Zm4.561,4.553h-3.918l3.918-3.918Zm.909-4.553h3.918l-3.918,3.918Zm4.561,4.553h-3.918l3.918-3.918Zm.909,0v-3.918l3.918,3.918Zm.643-4.553h3.918v3.918Z",
    transform: "translate(-10.004 -84.987)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47521",
    "data-name": "Path 47521",
    d: "M89.676,201.41H72.86l.619-7.052a3.691,3.691,0,0,1,3.683-3.377H85.17a3.706,3.706,0,0,1,3.675,3.275Z",
    transform: "translate(-15.767 -84.427)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12662",
    "data-name": "Rectangle 12662",
    width: 3.228,
    height: 3.228,
    transform: "translate(59.804 109.468)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12663",
    "data-name": "Rectangle 12663",
    width: 3.228,
    height: 3.228,
    transform: "translate(63.887 109.468)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12664",
    "data-name": "Rectangle 12664",
    width: 3.228,
    height: 3.228,
    transform: "translate(67.969 109.468)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47522",
    "data-name": "Path 47522",
    d: "M85.524,173.582a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,85.524,173.582Z",
    transform: "translate(-17.555 -80.185)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47523",
    "data-name": "Path 47523",
    d: "M151.141,225.011h0a1.881,1.881,0,0,1-1.881-1.881V221.25h3.761v1.881A1.881,1.881,0,0,1,151.141,225.011Z",
    transform: "translate(-32.301 -90.977)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47524",
    "data-name": "Path 47524",
    d: "M38.04,257.45,39.5,346.443H89.953l-.964-88.993Z",
    transform: "translate(-8.232 -98.811)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47525",
    "data-name": "Path 47525",
    d: "M42.1,260.74l.18,10.829.047,2.97.047,2.978H48.98l-.047-2.978-.039-2.97-.172-10.829Z",
    transform: "translate(-9.111 -99.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47526",
    "data-name": "Path 47526",
    d: "M58.26,260.74l.165,10.829.039,2.97.047,2.978h6.606l-.039-2.978-.039-2.97-.149-10.829Z",
    transform: "translate(-12.608 -99.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47527",
    "data-name": "Path 47527",
    d: "M74.42,260.74l.149,10.829.039,2.97.039,2.978h6.606l-.031-2.978-.039-2.97-.133-10.829Z",
    transform: "translate(-16.105 -99.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47528",
    "data-name": "Path 47528",
    d: "M90.59,260.74l.125,10.829.055,4.592.016,1.356H97.4l-.016-1.356-.055-4.592-.118-10.829Z",
    transform: "translate(-19.604 -99.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47529",
    "data-name": "Path 47529",
    d: "M42.61,288.41l.18,10.821.047,2.97.047,2.97H49.5l-.039-2.97-.047-2.97-.165-10.821Z",
    transform: "translate(-9.221 -105.511)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47530",
    "data-name": "Path 47530",
    d: "M58.73,288.41l.157,10.821.063,4.184.024,1.755h6.621l-.024-1.755-.055-4.184-.157-10.821Z",
    transform: "translate(-12.709 -105.511)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47531",
    "data-name": "Path 47531",
    d: "M74.84,288.41l.149,10.821.039,2.97.039,2.97h6.621l-.039-2.97-.039-2.97-.133-10.821Z",
    transform: "translate(-16.196 -105.511)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47532",
    "data-name": "Path 47532",
    d: "M90.96,288.41l.133,10.821.031,2.97.039,2.97h6.614l-.031-2.97-.031-2.97L97.6,288.41Z",
    transform: "translate(-19.684 -105.511)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47533",
    "data-name": "Path 47533",
    d: "M43.09,315.75l.172,10.774.055,2.962.047,2.954H49.97l-.047-2.954-.047-2.962-.157-10.774Z",
    transform: "translate(-9.325 -111.427)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47534",
    "data-name": "Path 47534",
    d: "M59.17,315.75l.157,10.774.039,2.962.047,2.954h6.606l-.039-2.954-.039-2.962-.149-10.774Z",
    transform: "translate(-12.805 -111.427)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47535",
    "data-name": "Path 47535",
    d: "M75.24,315.75l.141,10.774.039,2.962.039,2.954h6.614l-.039-2.954-.039-2.962-.133-10.774Z",
    transform: "translate(-16.282 -111.427)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47536",
    "data-name": "Path 47536",
    d: "M91.32,315.75l.125,10.774.047,4.09.024,1.826h6.606l-.016-1.826-.047-4.09-.118-10.774Z",
    transform: "translate(-19.762 -111.427)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47537",
    "data-name": "Path 47537",
    d: "M84.608,342.71H43.36l.094,5.846H87.947l-.063-5.846Z",
    transform: "translate(-9.383 -117.262)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47538",
    "data-name": "Path 47538",
    d: "M78.747,355.69H59.706l-.016,1.434h.572l.157,10.579h1.9l-.157-10.579H76.3l.133,10.579h1.9l-.125-10.579h.525Z",
    transform: "translate(-12.917 -120.071)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47539",
    "data-name": "Path 47539",
    d: "M70.169,368.1H63.117L62.96,357.52h7.068Z",
    transform: "translate(-13.625 -120.467)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47540",
    "data-name": "Path 47540",
    d: "M78.953,368.1H71.9L71.76,357.52h7.06Z",
    transform: "translate(-15.529 -120.467)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47541",
    "data-name": "Path 47541",
    d: "M151.121,264l.572,83.86H104.152L103.11,264Z",
    transform: "translate(-22.313 -100.229)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47542",
    "data-name": "Path 47542",
    d: "M141.8,344.58h14.23l.016,2.688.016,2.688.078,9.732h-6.026l-.078-10.007H138.457l-.047-5.1Z",
    transform: "translate(-29.953 -117.666)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47543",
    "data-name": "Path 47543",
    d: "M112.308,344.58h13.368l.055,5.1H114.3l.118,10.007H108.39l-.11-9.732-.047-3.887-.023-1.489Z",
    transform: "translate(-23.417 -117.666)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47544",
    "data-name": "Path 47544",
    d: "M124.137,356.6h16.385l.016,1.434h.18l.078,9.865h-1.771l-.086-9.865h-13.18l.1,9.865H124.09l-.11-9.865h.172Z",
    transform: "translate(-26.83 -120.268)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47545",
    "data-name": "Path 47545",
    d: "M134.664,368.3h6.582l-.086-9.865h-6.59Z",
    transform: "translate(-29.122 -120.664)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47546",
    "data-name": "Path 47546",
    d: "M126.442,368.3h6.582l-.094-9.865h-6.59Z",
    transform: "translate(-27.341 -120.664)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47547",
    "data-name": "Path 47547",
    d: "M137.31,268.32h18.266l.11,15.742H137.459Z",
    transform: "translate(-29.714 -101.163)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47548",
    "data-name": "Path 47548",
    d: "M107.09,268.32h18.266l.149,15.742H107.278Z",
    transform: "translate(-23.175 -101.163)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47549",
    "data-name": "Path 47549",
    d: "M137.96,293.58h17.482l.118,15.045H138.093Z",
    transform: "translate(-29.855 -106.63)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47550",
    "data-name": "Path 47550",
    d: "M107.79,293.58h17.482l.157,15.045H107.962Z",
    transform: "translate(-23.326 -106.63)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47551",
    "data-name": "Path 47551",
    d: "M138.19,319.69h17.584l.11,15.084h-17.56Z",
    transform: "translate(-29.905 -112.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47552",
    "data-name": "Path 47552",
    d: "M108.11,319.69h17.584l.149,15.084h-17.56Z",
    transform: "translate(-23.395 -112.28)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Company--inject-151",
    transform: "translate(125.994 54.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47553",
    "data-name": "Path 47553",
    d: "M160.83,84.62l2.923,3.777H297.638l2.946-3.777Z",
    transform: "translate(-160.799 -61.395)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51481",
    "data-name": "Group 51481",
    transform: "translate(0.031 23.225)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47554",
    "data-name": "Path 47554",
    d: "M160.83,84.62l2.923,3.777H297.638l2.946-3.777Z",
    transform: "translate(-160.83 -84.62)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12665",
    "data-name": "Rectangle 12665",
    width: 134.191,
    height: 237.884,
    transform: "translate(2.68 18.359)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51482",
    "data-name": "Group 51482",
    transform: "translate(2.68 18.359)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12666",
    "data-name": "Rectangle 12666",
    width: 134.191,
    height: 237.884,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51483",
    "data-name": "Group 51483",
    transform: "translate(2.698 21.391)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47555",
    "data-name": "Path 47555",
    d: "M169.653,85.1a2.437,2.437,0,0,1-2.4,2.8,3.134,3.134,0,0,1-2.993-2.8,2.445,2.445,0,0,1,2.406-2.821A3.134,3.134,0,0,1,169.653,85.1Z",
    transform: "translate(-164.233 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47556",
    "data-name": "Path 47556",
    d: "M175.964,85.1a2.46,2.46,0,0,1-2.429,2.8,3.134,3.134,0,0,1-2.962-2.8,2.46,2.46,0,0,1,2.421-2.821,3.134,3.134,0,0,1,2.97,2.821Z",
    transform: "translate(-165.599 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47557",
    "data-name": "Path 47557",
    d: "M182.265,85.1a2.476,2.476,0,0,1-2.445,2.8,3.072,3.072,0,0,1-2.946-2.8,2.484,2.484,0,0,1,2.445-2.821,3.072,3.072,0,0,1,2.946,2.821Z",
    transform: "translate(-166.963 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47558",
    "data-name": "Path 47558",
    d: "M188.566,85.1a2.507,2.507,0,0,1-2.468,2.8,3.048,3.048,0,0,1-2.923-2.8,2.515,2.515,0,0,1,2.476-2.821,3.04,3.04,0,0,1,2.915,2.821Z",
    transform: "translate(-168.328 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47559",
    "data-name": "Path 47559",
    d: "M194.877,85.1a2.531,2.531,0,0,1-2.492,2.8,3.017,3.017,0,0,1-2.9-2.8,2.531,2.531,0,0,1,2.492-2.821A3.009,3.009,0,0,1,194.877,85.1Z",
    transform: "translate(-169.694 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47560",
    "data-name": "Path 47560",
    d: "M201.177,85.1a2.555,2.555,0,0,1-2.515,2.8,2.985,2.985,0,0,1-2.876-2.8A2.555,2.555,0,0,1,198.3,82.28a2.978,2.978,0,0,1,2.876,2.821Z",
    transform: "translate(-171.058 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47561",
    "data-name": "Path 47561",
    d: "M207.508,85.1a2.578,2.578,0,0,1-2.539,2.8,2.954,2.954,0,0,1-2.852-2.8,2.57,2.57,0,0,1,2.531-2.821,2.962,2.962,0,0,1,2.86,2.821Z",
    transform: "translate(-172.428 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47562",
    "data-name": "Path 47562",
    d: "M213.786,85.1a2.6,2.6,0,0,1-2.57,2.8,2.923,2.923,0,0,1-2.829-2.8,2.6,2.6,0,0,1,2.555-2.821A2.931,2.931,0,0,1,213.786,85.1Z",
    transform: "translate(-173.786 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47563",
    "data-name": "Path 47563",
    d: "M220.089,85.1a2.625,2.625,0,0,1-2.578,2.8,2.9,2.9,0,0,1-2.813-2.8,2.625,2.625,0,0,1,2.586-2.821A2.891,2.891,0,0,1,220.089,85.1Z",
    transform: "translate(-175.152 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47564",
    "data-name": "Path 47564",
    d: "M226.4,85.1a2.656,2.656,0,0,1-2.609,2.8A2.86,2.86,0,0,1,221,85.1a2.649,2.649,0,0,1,2.6-2.821A2.868,2.868,0,0,1,226.4,85.1Z",
    transform: "translate(-176.516 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47565",
    "data-name": "Path 47565",
    d: "M232.7,85.1a2.68,2.68,0,0,1-2.625,2.8,2.844,2.844,0,0,1-2.766-2.8,2.672,2.672,0,0,1,2.625-2.821A2.837,2.837,0,0,1,232.7,85.1Z",
    transform: "translate(-177.882 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47566",
    "data-name": "Path 47566",
    d: "M239,85.1a2.7,2.7,0,0,1-2.649,2.8,2.821,2.821,0,0,1-2.743-2.8,2.7,2.7,0,0,1,2.649-2.821A2.805,2.805,0,0,1,239,85.1Z",
    transform: "translate(-179.246 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47567",
    "data-name": "Path 47567",
    d: "M245.311,85.1a2.727,2.727,0,0,1-2.672,2.8,2.782,2.782,0,0,1-2.719-2.8,2.727,2.727,0,0,1,2.672-2.821A2.79,2.79,0,0,1,245.311,85.1Z",
    transform: "translate(-180.611 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47568",
    "data-name": "Path 47568",
    d: "M251.612,85.1a2.7,2.7,0,1,1-2.7-2.821,2.75,2.75,0,0,1,2.7,2.821Z",
    transform: "translate(-181.976 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47569",
    "data-name": "Path 47569",
    d: "M257.913,85.1a2.774,2.774,0,0,1-2.711,2.8,2.727,2.727,0,0,1-2.672-2.8,2.774,2.774,0,0,1,2.711-2.821,2.727,2.727,0,0,1,2.672,2.821Z",
    transform: "translate(-183.34 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47570",
    "data-name": "Path 47570",
    d: "M264.221,85.1a2.805,2.805,0,0,1-2.743,2.8,2.7,2.7,0,0,1-2.649-2.8,2.805,2.805,0,0,1,2.735-2.821,2.711,2.711,0,0,1,2.656,2.821Z",
    transform: "translate(-184.704 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47571",
    "data-name": "Path 47571",
    d: "M270.511,85.1a2.837,2.837,0,0,1-2.758,2.8,2.688,2.688,0,0,1-2.633-2.8,2.837,2.837,0,0,1,2.766-2.821A2.68,2.68,0,0,1,270.51,85.1Z",
    transform: "translate(-186.065 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47572",
    "data-name": "Path 47572",
    d: "M276.83,85.1a2.868,2.868,0,0,1-2.79,2.8,2.649,2.649,0,0,1-2.6-2.8,2.86,2.86,0,0,1,2.782-2.821A2.656,2.656,0,0,1,276.83,85.1Z",
    transform: "translate(-187.432 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47573",
    "data-name": "Path 47573",
    d: "M283.121,85.1a2.9,2.9,0,0,1-2.837,2.8,2.633,2.633,0,0,1-2.586-2.8A2.891,2.891,0,0,1,280.5,82.28a2.625,2.625,0,0,1,2.617,2.821Z",
    transform: "translate(-188.786 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47574",
    "data-name": "Path 47574",
    d: "M289.421,85.1a2.915,2.915,0,0,1-2.821,2.8,2.609,2.609,0,0,1-2.6-2.8,2.923,2.923,0,0,1,2.829-2.821,2.6,2.6,0,0,1,2.594,2.821Z",
    transform: "translate(-190.149 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47575",
    "data-name": "Path 47575",
    d: "M295.739,85.1a2.954,2.954,0,0,1-2.852,2.8,2.578,2.578,0,0,1-2.539-2.8A2.946,2.946,0,0,1,293.2,82.28a2.586,2.586,0,0,1,2.539,2.821Z",
    transform: "translate(-191.523 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47576",
    "data-name": "Path 47576",
    d: "M302.038,85.1a2.978,2.978,0,0,1-2.868,2.8,2.562,2.562,0,0,1-2.523-2.8,2.978,2.978,0,0,1,2.876-2.821,2.555,2.555,0,0,1,2.515,2.821Z",
    transform: "translate(-192.885 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47577",
    "data-name": "Path 47577",
    d: "M308.348,85.1a3,3,0,0,1-2.892,2.8A2.539,2.539,0,0,1,303,85.1a3.009,3.009,0,0,1,2.9-2.821,2.531,2.531,0,0,1,2.453,2.821Z",
    transform: "translate(-194.259 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47578",
    "data-name": "Path 47578",
    d: "M314.647,85.1a3.04,3.04,0,0,1-2.915,2.8,2.508,2.508,0,0,1-2.476-2.8,3.033,3.033,0,0,1,2.915-2.821,2.515,2.515,0,0,1,2.476,2.821Z",
    transform: "translate(-195.613 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47579",
    "data-name": "Path 47579",
    d: "M320.946,85.1a3.072,3.072,0,0,1-2.938,2.8,2.492,2.492,0,0,1-2.453-2.8,3.072,3.072,0,0,1,2.939-2.821,2.492,2.492,0,0,1,2.453,2.821Z",
    transform: "translate(-196.976 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47580",
    "data-name": "Path 47580",
    d: "M327.261,85.1a3.134,3.134,0,0,1-2.939,2.8,2.461,2.461,0,0,1-2.429-2.8,3.134,3.134,0,0,1,2.962-2.821,2.468,2.468,0,0,1,2.406,2.821Z",
    transform: "translate(-198.346 -82.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47581",
    "data-name": "Path 47581",
    d: "M333.554,85.1a3.134,3.134,0,0,1-2.986,2.8,2.445,2.445,0,0,1-2.406-2.8,3.134,3.134,0,0,1,2.985-2.821,2.445,2.445,0,0,1,2.406,2.821Z",
    transform: "translate(-199.702 -82.28)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47582",
    "data-name": "Path 47582",
    d: "M160.82,79.74H300.59l-.008,3.824H160.828Z",
    transform: "translate(-160.796 -60.339)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47583",
    "data-name": "Path 47583",
    d: "M160.81,74.86l2.915,3.824H297.649L300.6,74.86Z",
    transform: "translate(-160.794 -59.283)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51484",
    "data-name": "Group 51484",
    transform: "translate(0.016 15.577)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47584",
    "data-name": "Path 47584",
    d: "M160.81,74.86l2.915,3.824H297.649L300.6,74.86Z",
    transform: "translate(-160.81 -74.86)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47585",
    "data-name": "Path 47585",
    d: "M160.79,69.96H300.6l-.008,3.84H160.806Z",
    transform: "translate(-160.79 -58.223)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51485",
    "data-name": "Group 51485",
    transform: "translate(2.923 15.577)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47586",
    "data-name": "Path 47586",
    d: "M164.52,74.86H298.46l-.008,3.824H164.528Z",
    transform: "translate(-164.52 -74.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51486",
    "data-name": "Group 51486",
    transform: "translate(2.719 94.681)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12667",
    "data-name": "Rectangle 12667",
    width: 134.183,
    height: 1.685,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51487",
    "data-name": "Group 51487",
    transform: "translate(2.993 178.298)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12668",
    "data-name": "Rectangle 12668",
    width: 133.901,
    height: 1.677,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12669",
    "data-name": "Rectangle 12669",
    width: 16.589,
    height: 17.921,
    transform: "translate(30.529 34.328)",
    fill: "#eb9929",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12670",
    "data-name": "Rectangle 12670",
    width: 16.589,
    height: 17.921,
    transform: "translate(62.39 34.328)",
    fill: "#eb9929",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12671",
    "data-name": "Rectangle 12671",
    width: 16.589,
    height: 17.921,
    transform: "translate(94.251 34.328)",
    fill: "#eb9929",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12672",
    "data-name": "Rectangle 12672",
    width: 16.589,
    height: 17.921,
    transform: "translate(30.529 61.159)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12673",
    "data-name": "Rectangle 12673",
    width: 16.589,
    height: 17.921,
    transform: "translate(62.39 61.159)",
    fill: "#eb9929",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12674",
    "data-name": "Rectangle 12674",
    width: 16.589,
    height: 17.921,
    transform: "translate(94.251 61.159)",
    fill: "#eb9929",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12675",
    "data-name": "Rectangle 12675",
    width: 16.589,
    height: 17.921,
    transform: "translate(30.529 191.204)",
    fill: "#eb9929",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12676",
    "data-name": "Rectangle 12676",
    width: 16.589,
    height: 17.921,
    transform: "translate(62.39 191.204)",
    fill: "#eb9929",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12677",
    "data-name": "Rectangle 12677",
    width: 16.589,
    height: 17.921,
    transform: "translate(94.251 191.204)",
    fill: "#eb9929",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12680",
    "data-name": "Rectangle 12680",
    width: 16.589,
    height: 17.921,
    transform: "translate(30.529 110.486)",
    fill: "#eb9929",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12681",
    "data-name": "Rectangle 12681",
    width: 16.589,
    height: 17.921,
    transform: "translate(62.39 110.486)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12682",
    "data-name": "Rectangle 12682",
    width: 16.589,
    height: 17.921,
    transform: "translate(94.251 110.486)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12683",
    "data-name": "Rectangle 12683",
    width: 16.589,
    height: 17.921,
    transform: "translate(30.529 137.316)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12684",
    "data-name": "Rectangle 12684",
    width: 16.589,
    height: 17.921,
    transform: "translate(62.39 137.316)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12685",
    "data-name": "Rectangle 12685",
    width: 16.589,
    height: 17.921,
    transform: "translate(94.251 137.316)",
    fill: "#eb9929",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51488",
    "data-name": "Group 51488",
    transform: "translate(50.471 231.034)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47587",
    "data-name": "Path 47587",
    d: "M225.318,349.82h17.169l-.071,17.827H225.2Z",
    transform: "translate(-225.2 -349.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51489",
    "data-name": "Group 51489",
    transform: "translate(70.884 231.034)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47588",
    "data-name": "Path 47588",
    d: "M251.438,349.82h17.874l-.846,17.827H251.25Z",
    transform: "translate(-251.25 -349.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47589",
    "data-name": "Path 47589",
    d: "M265.23,376.159h-45.3l-.18-3.589H265.4Z",
    transform: "translate(-173.549 -123.709)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51490",
    "data-name": "Group 51490",
    transform: "translate(46.201 248.861)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47590",
    "data-name": "Path 47590",
    d: "M265.23,376.159h-45.3l-.18-3.589H265.4Z",
    transform: "translate(-219.75 -372.57)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47591",
    "data-name": "Path 47591",
    d: "M266.61,381.014H217.886l-.2-3.534h49.1Z",
    transform: "translate(-173.103 -124.771)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51491",
    "data-name": "Group 51491",
    transform: "translate(42.816 220.683)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47592",
    "data-name": "Path 47592",
    d: "M267.735,340.646H215.657l-.227-4.036h52.509Z",
    transform: "translate(-215.43 -336.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47593",
    "data-name": "Path 47593",
    d: "M215.72,341.76l7.546,6.316h38.357l6.175-6.316Z",
    transform: "translate(-172.677 -117.041)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47594",
    "data-name": "Path 47594",
    d: "M220.22,345.4l2.664,21.157H225l-.854-21.157h0a4.286,4.286,0,0,0-3.918,0Z",
    transform: "translate(-173.651 -117.726)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47595",
    "data-name": "Path 47595",
    d: "M277.315,345.368l-2.609,21.157H272.59l.784-21.157h0a3.573,3.573,0,0,1,3.918,0Z",
    transform: "translate(-184.984 -117.696)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47603",
    "data-name": "Path 47603",
    d: "M164.52,74.86H298.46l-.008,3.824H164.528Z",
    transform: "translate(-161.597 -59.283)",
    fill: "#eb9929"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47596",
    "data-name": "Path 47596",
    d: "M193.44,60.9c0-3.463,2.656-5.916,6.269-5.916a6.01,6.01,0,0,1,4.9,2.147l-2.045,1.849a3.4,3.4,0,0,0-2.688-1.332,3.252,3.252,0,1,0,0,6.5,3.377,3.377,0,0,0,2.688-1.332l2.045,1.857a6.034,6.034,0,0,1-4.9,2.147C196.1,66.828,193.44,64.4,193.44,60.9Z",
    transform: "translate(-167.856 -50.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47597",
    "data-name": "Path 47597",
    d: "M208.44,60.906c0-3.409,2.688-5.916,6.331-5.916S221.1,57.5,221.1,60.906s-2.68,5.924-6.324,5.924S208.44,64.323,208.44,60.906Zm9.4,0a3.08,3.08,0,1,0-3.072,3.252,3.048,3.048,0,0,0,3.072-3.252Z",
    transform: "translate(-171.102 -50.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47598",
    "data-name": "Path 47598",
    d: "M237.029,66.666V60.632L234.1,65.545h-1.426L229.758,60.8v5.869H226.78V55.28h2.656l4,6.567,3.918-6.567H240V66.666Z",
    transform: "translate(-175.071 -51.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47599",
    "data-name": "Path 47599",
    d: "M256.8,59.5c0,2.578-1.951,4.192-5.054,4.192h-1.99v2.978H246.54V55.28h5.2C254.846,55.28,256.8,56.886,256.8,59.5Zm-3.252,0c0-1.058-.666-1.677-2-1.677h-1.794v3.33h1.794c1.332,0,2-.6,2-1.653Z",
    transform: "translate(-179.347 -51.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47600",
    "data-name": "Path 47600",
    d: "M268.146,64.468h-4.819l-.893,2.218H259.15L264.173,55.3h3.174l5.007,11.37h-3.346Zm-.948-2.351-1.465-3.636-1.457,3.636Z",
    transform: "translate(-182.076 -51.05)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47601",
    "data-name": "Path 47601",
    d: "M288.016,55.28V66.666h-2.649L280.344,60.6v6.065H277.21V55.28h2.649l5.023,6.049V55.28Z",
    transform: "translate(-185.984 -51.046)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47602",
    "data-name": "Path 47602",
    d: "M299.612,62.583v4.083h-3.221v-4.13L292.05,55.28h3.4l2.7,4.521,2.7-4.521h3.134Z",
    transform: "translate(-189.195 -51.046)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyBackground);
export default __webpack_public_path__ + "static/media/companyBackground.4d9109dab2af52733354551b4049574d.svg";
export { ForwardRef as ReactComponent };